import { SET_SUPER_USERS } from "./types";

import { apiCallV2 } from "../../utils/api";

export const GetSuperUsers =
    (page, count, filter, sort) => async (dispatch) => {
        const res = await apiCallV2(
            "GET",
            "admin/get-super-users-v2",
            "",
            localStorage.getItem("access-token"),
            {
                page: page,
                limit: count,
                filters: filter,
                sort: sort,
            }
        );

        let linked_companies = [];
        const admins = res.data.admin.map((a) => {
            linked_companies = a?.linked_companies ? JSON.parse(a?.linked_companies) : [];

            linked_companies = linked_companies?.map((lc) => {
                return {
                    ...lc,
                    companyName: lc?.company_details?.name
                };
            });

            return {
                ...a,
                companies: linked_companies
            }
        });

        if (res.status == 200) {
            dispatch({
                type: SET_SUPER_USERS,
                data: {
                    list: admins,
                    count: res.data.count[0]["count(*)"],
                },
            });
        }
    };

export const AddNewSuperUserToList = (user) => async (dispatch, getState) => {
    const { list, count } = getState().SuperUser;
    let temp = [...list];

    temp.unshift({
        ...user,
        companies: [
            {
                admin_id: user?.table_id,
                companyName: user?.name,
                company_id: user?.company,
                created_at: new Date(),
                id: user?.companySUAccess,
                status: 1,
            },
        ],
    });

    dispatch({
        type: SET_SUPER_USERS,
        data: {
            list: temp,
            count: count + 1,
        },
    });
};

export const RemoveSuperUserToList = (user) => async (dispatch, getState) => {
    const { list, count } = getState().SuperUser;
    let temp = [...list];

    temp = temp.filter((l) => l.user_id != user.user_id);

    dispatch({
        type: SET_SUPER_USERS,
        data: {
            list: temp,
            count: count,
        },
    });
};

export const UpdateCompanyAccess =
    (user, company, status, list) => async (dispatch, getState) => {
        const { count } = getState().SuperUser;

        const res = await apiCallV2(
            "POST",
            "admin/update-super-user-company-access",
            {
                user: user,
                company: company,
                status: status,
            },
            localStorage.getItem("access-token")
        );

        if (res.data.status == 200 && res.data.success) {
            let temp = [];

            const updated = list.map((l, i) => {
                if (l?.table_id == user) {
                    temp = l?.companies.map((c, i2) => {
                        return c?.company_id == company
                            ? {
                                ...c,
                                status: status,
                            }
                            : c;
                    });

                    return {
                        ...l,
                        companies: temp,
                    };
                } else {
                    return l;
                }
            });

            dispatch({
                type: SET_SUPER_USERS,
                data: {
                    list: updated,
                    count: count,
                },
            });

            return { success: true };
        } else {
            return { success: false };
        }
    };

export const AddCompanyAccess =
    (adminID, company, list) => async (dispatch, getState) => {
        const { count } = getState().SuperUser;
        const res = await apiCallV2(
            "POST",
            "admin/add-company-access",
            {
                adminID,
                companyID: company?.table_id,
            },
            localStorage.getItem("access-token")
        );


        if (res?.data?.status == 200) {
            const newCA = {
                admin_id: adminID,
                companyName: company?.name,
                company_id: company?.table_id,
                created_at: new Date(),
                id: res?.data?.data?.id,
                status: 1,
            };

            const updated = list.map((l, i) => {
                if (l?.table_id == adminID) {
                    return {
                        ...l,
                        companies: [...l?.companies, newCA],
                    };
                } else {
                    return l;
                }
            });

            dispatch({
                type: SET_SUPER_USERS,
                data: {
                    list: [...updated],
                    count: count,
                },
            });
            return { success: true };
        } else {
            return { success: false };
        }
    };
